import HttpConfiguratorRun from "./http.run";
import NotificationRun from "./notification.run";

import {momentRun} from "./moment.run";
import {accountCheckRun} from "./account-check";
import {updateCompanyRun} from "./updateCompany.run";
import {updateUserRun} from "./updateUser.run";

export const BootstrapModule = angular.module("app.bootstrap", [])
	.run(HttpConfiguratorRun)
	.run(NotificationRun)
	.run(momentRun)
	.run(accountCheckRun)
	.run(updateCompanyRun)
	.run(updateUserRun)
	.run(function (gettextCatalog) {
		gettextCatalog.setCurrentLanguage("en");
	});


// WEBPACK FOOTER //
// ./sources/bootstrap/bootstrap.js